import { createContext, useContext } from 'react';
import { FeedAccessView, FeedAdminMeta, FeedAdminSummary } from './types';

/**
 * Dữ liệu dùng chung cho mọi tab, ngăn chi tiết và hộp thoại của trang Bảng tin
 * (docs/bang-tin/03-admin.md §5.2). Đặt ở file riêng (không ở index.tsx như tài liệu) để các
 * tab không phải import ngược index.tsx (vòng import).
 */
export interface FeedCtx {
  access: FeedAccessView; // A1 — canPostAsPage, canMarkImportant, terms, limits, reportReasons
  meta: FeedAdminMeta | null; // D1
  summary: FeedAdminSummary | null; // D2, hỏi lại mỗi 60 s khi tab trình duyệt đang hiện
  isAdmin: boolean; // access.tier === 'ADMIN'
  myRank: number; // ADMIN 3 · PAGE_EDITOR 2 · SMOD 1 — làm mờ nút theo luật thứ bậc
  refreshKey: number; // tăng sau MỌI thao tác → các danh sách tự tải lại
  afterAction: () => void; // refreshKey+1, tải lại summary, refreshPendingCounts()
  openPost: (id: number, drawerTab?: string) => void; // đặt ?post=<id> (giữ tham số khác)
  goTab: (tab: string, params?: Record<string, string>) => void;
  reloadAccess: () => Promise<void>;
  /** Danh sách lý do báo cáo: D1 → A1 → dự phòng trong labels.ts. */
  reportReasonLabel: (value: string) => string;
  reportReasons: { value: string; label: string }[];
}

export const FeedContext = createContext<FeedCtx>(null as any);
export const useFeed = () => useContext(FeedContext);
